<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                {{year}} © IWK. 
            </div>
            <div class="col-sm-6">
                <div class="text-sm-end d-none d-sm-block">
                    version: {{versionNumber}}
                </div>
            </div>
        </div>
    </div>
</footer>